import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHiredNotifications } from '../../hooks/useHiredNotifications';
import HiredNotificationModal from './HiredNotificationModal';
import HiredNotificationErrorBoundary from './HiredNotificationErrorBoundary';

const HiredNotificationProviderInner = () => {
  const navigate = useNavigate();
  const { 
    pendingNotification, 
    acknowledgeHiredNotification 
  } = useHiredNotifications();

  const handleCloseHiredModal = useCallback(() => {
    if (pendingNotification?.applicationId) {
      acknowledgeHiredNotification(pendingNotification.applicationId);
    }
  }, [pendingNotification?.applicationId, acknowledgeHiredNotification]);

  const handleViewApplications = useCallback(() => {
    navigate('/applications');
  }, [navigate]);

  return (
    <HiredNotificationModal
      isOpen={!!pendingNotification}
      onClose={handleCloseHiredModal}
      onViewApplications={handleViewApplications}
      jobTitle={pendingNotification?.jobTitle}
      companyName={pendingNotification?.companyName}
      applicationId={pendingNotification?.applicationId}
    />
  );
};

const HiredNotificationProvider = () => {
  return (
    <HiredNotificationErrorBoundary>
      <HiredNotificationProviderInner />
    </HiredNotificationErrorBoundary>
  );
};

export default HiredNotificationProvider;